import { render } from "./LoadingDialog.vue?vue&type=template&id=15b36a66"
import script from "./LoadingDialog.vue?vue&type=script&lang=js"
export * from "./LoadingDialog.vue?vue&type=script&lang=js"
script.render = render

export default script